(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["job-form"] && !Shopify.designMode) return;
  try {
    
// document.addEventListener('DOMContentLoaded', function() {
//   const jobFormInitializer = {
//     validationScriptUrl: 'https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/jquery.validate.min.js',
//     additionalMethodsUrl: 'https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/additional-methods.min.js',
//     loadScript: function(src, callback) {
//       const script = document.createElement('script'); script.src = src; script.onload = callback; script.onerror = function() { console.error('Job Form Error: Failed to load script ' + src); }; document.head.appendChild(script);
//     },
//     initValidation: function() {
//       const $ = window.jQuery;
//       $('.job-form-js').each(function() {
//         const form = $(this); const sectionId = form.data('section-id'); const fileInput = $('#file-upload-' + sectionId); const fileNameDisplay = $('#file-name-display-' + sectionId);
//         fileInput.on('change', function() { if (this.files && this.files.length > 0) { fileNameDisplay.text('Selected file: ' + this.files[0].name); } else { fileNameDisplay.text(''); } });
//         if ($.validator && !$.validator.methods.filesize) { $.validator.addMethod('filesize', function (value, element, param) { return this.optional(element) || (element.files[0].size <= param); }, 'File must be less than 5MB.'); }
        
//         form.validate({
//           // --- THIS IS THE FIX ---
//           // Tell the validator to NOT ignore hidden fields that are of type="file"
//           ignore: ":hidden:not([type=file])",

//           errorElement: 'div', errorClass: 'error-message',
//           highlight: function(element, errorClass, validClass) {
//             $(element).addClass(errorClass).removeClass(validClass);
//             // Also add error class to the custom file upload wrapper
//             if ($(element).attr('type') === 'file') {
//               $(element).closest('.custom-file-upload-wrapper').addClass(errorClass);
//             }
//           },
//           unhighlight: function(element, errorClass, validClass) {
//             $(element).removeClass(errorClass).addClass(validClass);
//             if ($(element).attr('type') === 'file') {
//               $(element).closest('.custom-file-upload-wrapper').removeClass(errorClass);
//             }
//           },
//           errorPlacement: function(error, element) {
//             // For the file input, place the error after its wrapper for better layout
//             if (element.attr('type') === 'file') {
//               error.insertAfter(element.closest('.custom-file-upload-wrapper'));
//             } else {
//               error.appendTo(element.closest('.input-box'));
//             }
//           },
//           rules: {
//             'contact[Full Name]': { required: true, minlength: 2 }, 'contact[email]': { required: true, email: true }, 'contact[Phone Number]': { required: true, minlength: 7, digits: true }, 'contact[City]': { required: true }, 'contact[Country]': { required: true },
//             'contact[attachment]': { required: true, extension: "pdf|doc|docx", filesize: 5242880 }
//           },
//           messages: {
//             'contact[Full Name]': { required: "Please enter your full name.", minlength: "Your name must be at least 2 characters long." }, 'contact[email]': { required: "Please enter your email address.", email: "Please enter a valid email address." }, 'contact[Phone Number]': { required: "Please enter your phone number.", minlength: "Please enter a valid phone number.", digits: "Please use only numbers." }, 'contact[City]': "Please enter your city.", 'contact[Country]': "Please enter your country.",
//             'contact[attachment]': { required: "Please upload your CV or resume.", extension: "Please upload a valid file type (PDF, DOC, DOCX)." }
//           },
//           submitHandler: function(form) { form.submit(); }
//         });
//       });
//     },
//     start: function() {
//       let attempts = 0; const maxAttempts = 50;
//       const interval = setInterval(() => {
//         if (typeof window.jQuery !== 'undefined') {
//           clearInterval(interval);
//           if (typeof window.jQuery.validator === 'undefined') {
//             this.loadScript(this.validationScriptUrl, () => { this.loadScript(this.additionalMethodsUrl, () => { this.initValidation(); }); });
//           } else { this.initValidation(); }
//         } else if (attempts++ > maxAttempts) { clearInterval(interval); console.error('Job Form Error: jQuery did not load in time.'); }
//       }, 100);
//     }
//   };
//   jobFormInitializer.start();
// });
document.addEventListener('DOMContentLoaded', function() {
  const jobFormInitializer = {
    validationScriptUrl: 'https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/jquery.validate.min.js',
    additionalMethodsUrl: 'https://cdn.jsdelivr.net/npm/jquery-validation@1.19.5/dist/additional-methods.min.js',
    loadScript: function(src, callback) {
      const script = document.createElement('script');
      script.src = src;
      script.onload = callback;
      script.onerror = function() { console.error('Job Form Error: Failed to load script ' + src); };
      document.head.appendChild(script);
    },
    initValidation: function() {
      const $ = window.jQuery;
      $('.job-form-js').each(function() {
        const form = $(this);
        
        form.validate({
          errorElement: 'div',
          errorClass: 'error-message',
          highlight: function(element, errorClass, validClass) {
            $(element).addClass(errorClass).removeClass(validClass);
          },
          unhighlight: function(element, errorClass, validClass) {
            $(element).removeClass(errorClass).addClass(validClass);
          },
          errorPlacement: function(error, element) {
            // Place the error message inside the parent '.input-box' for all fields.
            error.appendTo(element.closest('.input-box'));
          },
          rules: {
            'contact[Full Name]': { required: true, minlength: 2 },
            'contact[email]': { required: true, email: true },
            'contact[Phone Number]': { required: true, minlength: 7, digits: true },
            'contact[City]': { required: true },
            'contact[Country]': { required: true },
            // --- ADDED: Validation rule for the new Message field ---
            'contact[Message]': { required: true, minlength: 10 }
          },
          messages: {
            'contact[Full Name]': { required: "Please enter your full name.", minlength: "Your name must be at least 2 characters long." },
            'contact[email]': { required: "Please enter your email address.", email: "Please enter a valid email address." },
            'contact[Phone Number]': { required: "Please enter your phone number.", minlength: "Please enter a valid phone number.", digits: "Please use only numbers." },
            'contact[City]': "Please enter your city.",
            'contact[Country]': "Please enter your country.",
            // --- ADDED: Validation messages for the new Message field ---
            'contact[Message]': { required: "Please enter your message.", minlength: "Your message must be at least 10 characters long." }
          },
          submitHandler: function(form) {
            form.submit();
          }
        });
      });
    },
    start: function() {
      let attempts = 0;
      const maxAttempts = 50;
      const interval = setInterval(() => {
        if (typeof window.jQuery !== 'undefined') {
          clearInterval(interval);
          if (typeof window.jQuery.validator === 'undefined') {
            this.loadScript(this.validationScriptUrl, () => {
              this.loadScript(this.additionalMethodsUrl, () => {
                this.initValidation();
              });
            });
          } else {
            this.initValidation();
          }
        } else if (attempts++ > maxAttempts) {
          clearInterval(interval);
          console.error('Job Form Error: jQuery did not load in time.');
        }
      }, 100);
    }
  };
  jobFormInitializer.start();
});

  } catch(e) { console.error(e); }
})();
})();
